<template>
  <b-modal
    :ref="(widgetKey) ? 'editPostModal' : 'addPostModal'"
    hide-footer
    centered
    :title="(widgetKey) ? 'Update Post widget' : 'Create Post widget'"
    >
    <b-form @submit.prevent="submit" novalidate>
      <b-form-group label="Name:">
        <b-form-input
          v-model="$v.name.$model"
          :class="{ 'is-invalid': $v.name.$error }"
          type="text"
          /> 
        <b-form-invalid-feedback v-if="!$v.name.required">Name must be provided</b-form-invalid-feedback>
      </b-form-group>
      <b-button
        v-if="widgetKey"
        type="submit"
        :disabled="inProgress"
        >
        Update
      </b-button>
      <b-button
        v-else
        type="submit"
        :disabled="inProgress"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'
// helpers
import * as eventsBusHolder from '@/helpers/events-bus-holder'
import { required } from "vuelidate/lib/validators";

export default {
  props: ['widgetKey'],
  data () {
    return {
      name: '',
      description: '',
      inProgress: false,
      eventsHolder: eventsBusHolder.createHolder(),
      gsOptions: {}
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
    ])
  },
  methods: {
    fillData () {
      // const {name = '', dataProvider = ''} = this.pivotGridOptions[this.widgetKey] || {};
      // this.name = name;
      this.dataProviderOptions = Object.keys(this.dataGrid_options || {});
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid || this.inProgress) return
      this.inProgress = true

      let data = {
        name: this.name,
        tab: this.currentTab,
        subtab: this.currentSubTab,
        subtab: this.currentSubTab || null,
        gsOptions: this.gsOptions
      }

      if (this.widgetKey) data.table = this.widgetKey;

      let createCallback = (widgetKey) => {
        this.$store.commit('addedWidgetKey', widgetKey);
        this.gsOptions = {};
        this.$store.commit('deleteProcess', 'createPost')
        this.inProgress = false
        this.$nextTick(() => {
          if (this.$refs.addPostModal) this.$refs.addPostModal.hide()
          this.$v.$reset()
        })
      }

      let updateCallback = () => {
        this.$store.commit('deleteProcess', 'updatePost')
        this.$nextTick(() => {
          if (this.$refs.editPostModal) this.$refs.editPostModal.hide()
          this.$v.$reset()
        })
        this.inProgress = false
      }

      if (this.widgetKey) {
        this.$store.commit('addProcess', {
          process: 'updatePost',
          message: 'Updating'
        })
        db.posts.widget.update(data, updateCallback)
      } else {
        this.$store.commit('addProcess', {
          process: 'createPost',
          message: 'Creating'
        })
        db.posts.widget.create(data, createCallback)
      }
    },
  },
  created () {
    this.eventsHolder.$on('showAddPostsWidgetModal', ({gsOptions}) => {
      if (this.$refs.addPostModal) {
        this.gsOptions = gsOptions;
        this.fillData()
        this.$refs.addPostModal.show()
      }
    })
    this.eventsHolder.$on('showEditPostsWidgetModal', () => {
      if (this.$refs.editPostModal) {
        this.fillData()
        this.$refs.editPostModal.show()
      }
    })
  },
  validations: {
    description: {

    },
    name: {
      required
    }
  },
  mounted () {
    if (this.$refs.addPostModal) {
      $(this.$refs.addPostModal['$el']).appendTo('body')
    }
    if (this.$refs.editPostModal) {
      $(this.$refs.editPostModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    this.eventsHolder.clear()

    if (this.$refs.addPostModal) {
      $(this.$refs.addPostModal['$el']).remove()
    }
    if (this.$refs.editPostModal) {
      $(this.$refs.editPostModal['$el']).remove()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.PostData {
  @include cf;
  &__item {
    @include span(4);
  }
}
</style>
